import { intercept, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { Button, Col, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { EInput } from 'src/Components/EInput';
import DeepCopy from 'src/UtilityFunctions/DeepCopy';
import { IContact, IWell } from '../../../../Interfaces/WellInterface';
import DataService from '../../../../Services/Data';
import InputMask from '../../../../Services/InputMask';
import DataTable from '../../../DataTable';




const inputMask = new InputMask();


interface IParams {
    wellId: number | string;
}

interface IList {
    headers: any[];
    rows: any[];
}

const data = new DataService();

@inject('stores')
@observer
class Contacts extends React.Component {
    public props: any;
    private dataSet: IList;
    public params: IParams;
    public newContact: IContact = new IContact();
    private contacts: IContact[] = [];
    public WellsStore: any;
    public well: IWell = new IWell();
    private capName: string;
    public wellDisposer: any;
    public disposer: any;

    public state = {
        addModal: false,
        contacts: this.contacts,
        dataSet: this.dataSet,
        newContact: this.newContact,
        suggestedContacts: [],
        well: this.well
    };

    constructor(props: any) {
        super(props);
        this.capName = this.props.type.charAt(0).toUpperCase() + this.props.type.slice(1);
        this.WellsStore = this.props.stores.WellsStore;

        this.params = this.props.match.params;

        this.toggleModal = this.toggleModal.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.addContactToModel = this.addContactToModel.bind(this);
        this.handleNewInputChange = this.handleNewInputChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleRowDelete = this.handleRowDelete.bind(this);
        this.handleAutoSuggest = this.handleAutoSuggest.bind(this);
        this.selectContact = this.selectContact.bind(this);
    }

    public componentWillMount() {
        this.setState({
            well: toJS(this.props.well),
            wellId: this.props.wellId
        });
        this.createDisposers();
        this.WellsStore.getContactsType(this.props.wellId, this.props.type);
    }

    public componentDidMount() {
        this.formatDataTable();
    }

    public createDisposers() {
        this.disposer = intercept(this.WellsStore, 'contacts', (change: any) => {
            this.setState({
                contacts: change.newValue
            });
            return change;
        });
    }

    public componentWillReceiveProps(nextProps: any) {
        if ( this.props.well !== nextProps.well ) {
            this.setState({
                well: toJS(nextProps.well)
            }, () => {
                this.formatDataTable();
            });
        }
    }

    public componentWillUnmount() {
        this.disposer();
    }

    private formatDataTable() {
        const newDataList: any[] = [];
        const tableHeaders = [
            'Contact',
            'Type',
            'Mobile Phone',
            'Email'
        ];
        if ( this.state.well[this.props.type + 'Contacts'] ) {
            this.state.well[this.props.type + 'Contacts'].map((contact: IContact, index: number) => {
                const newObject = [
                    {
                        content: contact.firstName + ' ' + contact.lastName
                    },
                    {
                        content: contact.otherTypeName === '' || contact.otherTypeName === undefined ? this.capName : contact.otherTypeName
                    },
                    {
                        content: contact.phoneMobile
                    },
                    {
                        content: contact.email
                    }
                ];
                newDataList.push(newObject);
            });
        }
        const listStructure = {
            headers: tableHeaders,
            rows: newDataList
        };
        this.setState({
            dataSet: listStructure
        });
    }

    private handleNewInputChange(event: any) {
        const newContact = this.state.newContact;
        const mask = event.target.getAttribute('data-mask');
        if ( mask && inputMask[mask] ) {
            const masked = inputMask[mask](event.target.value);
            newContact[event.target.name] = masked;
        } else {
            newContact[event.target.name] = event.target.value;
        }
        this.setState({
            newContact
        });
    }

    private handleKeyDown(event: any) {
        if ( event.keyCode === 13 ) {
            this.addContactToModel();
        }
    }

    private addContactToModel(event?: any) {
        const well = this.state.well;
        if (this.state.newContact.id === "" && well[this.props.type + 'Contacts'].indexOf(this.state.newContact) < 0) {
            well[this.props.type + 'Contacts'].push(this.state.newContact);
        } else {
            const index = well[this.props.type + 'Contacts'].findIndex((value:any) => value.id === this.state.newContact.id);
            well[this.props.type + 'Contacts'][index] = this.state.newContact;
        }
        this.setState({
            newContact: new IContact(),
            well,
        });
        this.props.handleChange(well);
        this.formatDataTable();
        if ( !event || event.target.id !== 'addAnother' ) {
            this.toggleModal();
        }
    }

    private toggleModal() {
        this.setState({
            addModal: !this.state.addModal,
            newContact: new IContact(),
        });
    }

    private handleChange(event: any) {
        const well = this.state.well;
        well.operator[event.target.name] = event.target.value;
        this.setState({
            well
        });
        this.props.handleChange(well);
    }

    private handleEdit = (index: number) => {
        this.setState({
            addModal: true,
            newContact: DeepCopy(this.state.well[this.props.type + 'Contacts'][index])
        });
    }
    private handleRowDelete(index: number) {
        const well = this.state.well;
        const contacts = this.state.well[this.props.type + 'Contacts'];
        contacts.splice(index, 1);
        well[this.props.type + 'Contacts'] = contacts;
        this.setState({
            well
        });
        this.props.handleChange(well);
        this.formatDataTable();
    }

    public handleAutoSuggest(filter: string) {
        const filteredList = data.search(
            this.state.contacts,
            filter,
            ['lastName', 'firstName']
        );
        const loopList = filteredList || [];
        const newArray: any[] = [];
        loopList.map((row: any, index: number) => {
            newArray.push({
                display: row.firstName + ' ' + row.lastName,
                id: row.id,
                returnObject: row
            });
        });
        this.setState({
            suggestedContacts: newArray
        });
    }

    public selectContact(contact: any) {
        this.setState({
            newContact: contact,
            suggestedContacts: []
        });
    }

    public newContactNotComplete() {
        const contact = this.state.newContact;
        const regMatch = /D?(\d{3})\D?\D?(\d{3})\D?(\d{4})/;
        const phoneMatched = regMatch.test(contact.phoneMobile);
        return (contact.firstName === '' || (contact.phoneMobile !== '' && !phoneMatched));
    }

    public render() {
        return(
            <div style={{marginTop: '32px'}}>
                <Row>
                    <Col md="3">
                        <h3>{ this.props.type === 'other' ? 'Other Contacts' : this.capName + ' Rep' }</h3>
                    </Col>
                    <Col md="5">
                        <h3>
                            {this.state.well[this.props.type] && this.state.well[this.props.type][this.props.type + 'Name']}
                        </h3>
                    </Col>
                    {/* <Col md="4">
                        { this.state.well[this.props.type] && 
                        <FormGroup row={true}>
                            <Label lg="4" style={{textAlign: 'right', fontWeight: 'bold'}}>Email</Label>
                            <Col lg="8">
                                <EInput type="text" name="email" id="email" style={{width: '100%'}} disabled={true} onChange={this.handleChange} value={this.state.well[this.props.type].groupEmail} />
                            </Col>
                        </FormGroup>
                        }
                    </Col> */}
                </Row>
                <DataTable
                    list={this.state.dataSet}
                    onDelete={this.handleRowDelete}
                    onEdit={this.handleEdit}
                    onNew={{
                        callback: this.toggleModal,
                        text: 'Add ' + this.capName
                    }}
                />
                <Modal key={this.props.type+"-contact-modal"} isOpen={this.state.addModal} toggle={this.toggleModal} backdrop="static">
                    <ModalHeader toggle={this.toggleModal}>{ this.state.newContact.id === "" ? "Add" : "Edit"} a Contact</ModalHeader>
                    <ModalBody>
                        <Form>
                            {/* 
                            Removed per MUD-3263
                            <Row>
                                <Col lg="12" md="12">
                                    <FormGroup>
                                        <AutoSuggest
                                            placeholder="Search for Contact"
                                            inline={false}
                                            keyUp={this.handleAutoSuggest}
                                            list={this.state.suggestedContacts}
                                            onSelect={this.selectContact}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row> */}
                            { this.props.type === 'other' &&
                            <Row>
                                <Col lg="6" md="12">
                                    <FormGroup>
                                        <Label>Other Type</Label>
                                        <EInput
                                            type="text"
                                            name="otherTypeName"
                                            id="otherTypeName"
                                            placeholder="Other Type"
                                            value={this.state.newContact.otherTypeName}
                                            onKeyDown={this.handleKeyDown}
                                            required={true}
                                            onChange={this.handleNewInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>}
                            <Row>
                                <Col lg="6" md="12">
                                    <FormGroup>
                                        <Label>First Name</Label>
                                        <EInput
                                            type="text"
                                            name="firstName"
                                            id="firstName"
                                            placeholder="First Name"
                                            value={this.state.newContact.firstName}
                                            onKeyDown={this.handleKeyDown}
                                            onChange={this.handleNewInputChange}
                                            required={true}
                                            disabled={this.state.newContact.id !== ""}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="6" md="12">
                                    <FormGroup>
                                        <Label>Last Name</Label>
                                        <EInput
                                            type="text"
                                            name="lastName"
                                            id="lastName"
                                            placeholder="Last Name"
                                            value={this.state.newContact.lastName}
                                            onKeyDown={this.handleKeyDown}
                                            onChange={this.handleNewInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                            <Col lg="6" md="12">
                                    <FormGroup>
                                        <Label>Mobile Phone</Label>
                                        <EInput
                                            type="text"
                                            name="phoneMobile"
                                            id="phoneMobile"
                                            placeholder="Mobile Phone"
                                            data-mask="phoneMask"
                                            value={this.state.newContact.phoneMobile}
                                            onKeyDown={this.handleKeyDown}
                                            onChange={this.handleNewInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="6" md="12">
                                    <FormGroup>
                                        <Label>Email</Label>
                                        <EInput
                                            type="text"
                                            name="email"
                                            id="email"
                                            data-validation="email"
                                            placeholder="Email"
                                            value={this.state.newContact.email}
                                            onChange={this.handleNewInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleModal}>Cancel</Button>{' '}
                        <Button color="primary" id="saveAndClose" disabled={this.newContactNotComplete()} onClick={this.addContactToModel}>Update</Button>{' '}
                        {this.state.newContact.id === "" &&
                            <Button color="primary" id="addAnother" disabled={this.newContactNotComplete()} onClick={this.addContactToModel}>Add Another</Button>
                        }
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default withRouter(Contacts);



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellContacts/ContactList.tsx